import React from 'react';
import './Projects.css';
import { Link } from 'react-router-dom';
import Roofconversion from '../Assets/project-roof-conversion.jpg';
import Kitchen from '../Assets/Project-Modern-Kitchen.jpg';

const Projects = () => {
  // Project data array
  const projects = [
    {
      id: 1,
      title: "Luxury Wooden Deck",
      category: "Wood & Timber Work",
      image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf",
      description: "Custom-built teak deck with cedar pergola featuring intricate joinery and weather-resistant finishes."
    },
    {
      id: 2,
      title: "Roof Conversion",
      category: "Roof Conversions & Extensions",
      image: Roofconversion,
      description: "Transformed attic space into a bright master suite with dormer windows and custom skylights."
    },
    {
      id: 3,
      title: "Hardwood Floor Restoration",
      category: "Wood Flooring & Cabinets",
      image: "https://images.unsplash.com/photo-1600585152220-90363fe7e115",
      description: "Century-old oak floors restored to original glory using traditional techniques and modern sealants."
    },
    {
      id: 4,
      title: "Double-Glaze Windows & Doors",
      category: "Doors & Windows",
      image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d",
      description: "Full-home window upgrade with double-glazed argon-filled units reducing energy costs by 30%."
    },
    {
      id: 5,
      title: "Modern Chef's Kitchen",
      category: "Professional Kitchen Installation",
      image: Kitchen,
      description: "Custom walnut cabinetry with quartz countertops and professional-grade appliance integration."
    },
    {
      id: 6,
      title: "Custom Wardrobes",
      category: "Wood & Timber Work",
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7",
      description: "Floor-to-ceiling oak wardrobes with hidden storage solutions and soft-close mechanisms."
    },
    {
      id: 7,
      title: "Roof Extension",
      category: "Roof Conversions & Extensions",
      image: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154",
      description: "Traditional thatched roof extension blending seamlessly with existing 18th century cottage."
    },
    {
      id: 8,
      title: "Kitchen Cabinets",
      category: "Wood Flooring & Cabinets",
      image: "https://images.unsplash.com/photo-1600121848594-d8644e57abab",
      description: "Hand-painted shaker-style cabinets with custom organizational features and pull-out pantries."
    }
  ];

  return (
    <div className="projects-page">
      {/* Hero Banner */}
      <section className="projects-hero">
        <div className="hero-content">
          <h1>Our Portfolio of Work</h1>
          <p className="subtitle">Quality craftsmanship showcased through our completed projects</p>
        </div>
      </section>

      {/* Project Gallery */}
      <section className="project-gallery">
        <div className="container">
          <div className="gallery-header">
            <h2>Featured Projects</h2>
            <p className="gallery-intro">
              Browse our collection of completed works showcasing our expertise across all construction specialties.
            </p>
          </div>

          {/* Projects Grid */}
          <div className="projects-grid">
            {projects.map((project) => (
              <div className="project-card" key={project.id}>
                <div 
                  className="project-image" 
                  style={{ backgroundImage: `url(${project.image})` }}
                >
                  <div className="image-overlay">
                    <span className="project-category">{project.category}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <Link to="/gallery"><button className="view-project-btn">View Project Details</button></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="project-testimonials">
        <div className="container">
          <h2>Client Testimonials</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"A highly professional service that maximizes space and functionality while maintaining structural integrity. The team efficiently handles loft conversions, roof extensions, and dormer installations with a strong focus on insulation, ventilation, and compliance with building regulations. Their ability to blend new structures seamlessly with existing architecture makes them a top choice for homeowners looking to expand their living space."</p>
                <div className="client-info">
                  <span className="client-name">Surinder Singh</span>
                  <span className="project-type">Kitchen Renovation</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"This service excels in transforming interiors with premium wood flooring and custom cabinetry. The flooring installations are flawless, offering durability and timeless appeal, while the cabinetry work showcases fine craftsmanship, smart storage solutions, and tailored designs. Clients can expect a perfect balance of functionality and elegance, making it ideal for modern homes and businesses."</p>
                <div className="client-info">
                  <span className="client-name">Ishwar Gaurang</span>
                  <span className="project-type">Loft Conversion</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"A standout service offering energy-efficient, secure, and stylish door and window solutions. The double-glazing installations enhance thermal efficiency and noise reduction, while the custom doors and windows are built to high standards for longevity and visual appeal. The team ensures precise fitting, improving both aesthetics and home performance."</p>
                <div className="client-info">
                  <span className="client-name">Yangla Ruit</span>
                  <span className="project-type">Double Glaze Doors & Windows</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="projects-cta">
        <div className="container">
          <h2>Ready to Start Your Project?</h2>
          <p>Let's discuss how we can bring your vision to life with our expert construction services.</p>
          <div className="cta-buttons">
            <button className="primary-cta">Request a Consultation</button>
            <button className="secondary-cta">Call: 07853497378</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;